export default __webpack_public_path__ + "static/media/pint-house-mobile.82d68b36.jpg";